import dayjs from 'dayjs'
import { formatarCnpj } from './cnpj'

export const formatCurrency = (value: number | null | undefined): string => {
  if (value === null || value === undefined || isNaN(value)) {
    return 'R$ 0,00'
  }

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value)
}

export const formatNumber = (value: number | null | undefined): string => {
  if (value === null || value === undefined || isNaN(value)) {
    return '0'
  }

  return new Intl.NumberFormat('pt-BR').format(value)
}

export const formatPercent = (value: number | null | undefined): string => {
  if (value === null || value === undefined || isNaN(value)) {
    return '0%'
  }

  return `${value.toFixed(2).replace('.', ',')}%`
}

export const formatDate = (date: string | Date | null | undefined): string => {
  if (!date) {
    return '-'
  }

  return dayjs(date).format('DD/MM/YYYY')
}

export const formatDateTime = (date: string | Date | null | undefined): string => {
  if (!date) {
    return '-'
  }

  return dayjs(date).format('DD/MM/YYYY HH:mm')
}

export const formatTime = (date: string | Date | null | undefined): string => {
  if (!date) {
    return '-'
  }

  return dayjs(date).format('HH:mm')
}

/** XX.XXX.XXX/XXXX-XX — numérico ou alfanumérico (ver `@/utils/cnpj`). */
export const formatCNPJ = (cnpj: string | null | undefined): string => formatarCnpj(cnpj)

export const formatCPF = (cpf: string | null | undefined): string => {
  if (!cpf) return ''

  const cleaned = cpf.replace(/\D/g, '')
  return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}

export const formatPhone = (phone: string | null | undefined): string => {
  if (!phone) return ''

  const cleaned = phone.replace(/\D/g, '')

  if (cleaned.length === 10) {
    return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
  }

  if (cleaned.length === 11) {
    return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
  }

  return phone
}

export const truncateText = (text: string | null | undefined, length: number = 100): string => {
  if (!text) return ''
  if (text.length <= length) return text
  return `${text.substring(0, length)}...`
}

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}

export const capitalize = (text: string | null | undefined): string => {
  if (!text) return ''
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
}

export const getInitials = (name: string | null | undefined): string => {
  if (!name) return ''
  return name
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase())
    .join('')
    .substring(0, 2)
}

export const parseCurrency = (value: string): number => {
  const clean = value.replace(/[^\d,-]/g, '').replace(',', '.')
  return parseFloat(clean) || 0
}
